import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const BlogCard = ({ blog }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      whileHover={{ y: -8, scale: 1.03 }}
      className="bg-white rounded-3xl overflow-hidden cursor-pointer"
      style={{ border: "1px solid rgba(26, 172, 139, 0.15)" }}
      onClick={() => navigate(`/blogs/${blog.id}`)}
    >
      <img
        src={blog.image}
        alt={blog.title}
        className="h-48 w-full object-cover"
      />

      <div className="p-5">
        <h3 className="text-lg font-bold mb-2 text-[#1AAC8B]">
          {blog.title}
        </h3>

        {/* <p className="text-sm text-[#1AAC8B] mb-2">
          {blog.subtitle}
        </p> */}

        <p className="text-xs text-[#6B7A99] mb-3">
          {blog.excerpt}
        </p>

        <p className="text-xs text-gray-400">
          {blog.author} • {blog.date}
        </p>
      </div>
    </motion.div>
  );
};

export default BlogCard;